<template>
	<LoginComponentAdSpace v-if="isInTestGroup" />
	<LoginComponent v-else />
</template>

<script setup lang="ts">
import LoginComponent from '@components/login/login-component.vue';
import LoginComponentAdSpace from '@components/login/login-component-ad-space.vue';
import { ref } from 'vue';
import { useHead } from '@unhead/vue';
import { useMixpanel } from '@utils/composables/use-mixpanel';

const title = 'Log in';

const isInTestGroup = ref(false);
const loading = ref(true);

async function setup(): Promise<void> {
	useHead({
		meta: [{ property: 'og:title', content: title }],
		title
	});

	try {
		const { trackMixpanelView } = useMixpanel();
		if (isInTestGroup.value) {
			trackMixpanelView('Page', {
				'View Name': 'Login',
				'View Content': 'Ad Unit - Income Fund yield promo',
				'View Title': 'Building momentum'
			});
		} else {
			trackMixpanelView('Page', {
				'View Name': 'Login'
			});
		}
	} catch {
	} finally {
		loading.value = false;
	}
}

setup();
</script>
